import { useQuery } from '@apollo/react-hooks';
import DefaultAvatar from '@ifca-root/react-component/src/assets/images/default-avatar.png';
import Authentication from '@ifca-root/react-component/src/assets/icons/authentication.svg';
import Logout from '@ifca-root/react-component/src/assets/icons/logout.svg';
import Cover from '@ifca-root/react-component/src/assets/images/calendar-bg.jpg';
import theme from '@ifca-root/react-component/src/assets/theme';
import IconItem from '@ifca-root/react-component/src/components/Avatar/IconItem';
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents';
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import EmailText from '@ifca-root/react-component/src/components/Typography/EmailText';
import PhoneText from '@ifca-root/react-component/src/components/Typography/PhoneText';
import {
	Button,
	IconButton,
	List,
	ListItem,
	ListItemSecondaryAction,
	ListItemText,
	Switch,
	useMediaQuery,
} from '@material-ui/core';
import { Edit, KeyboardArrowRight } from '@material-ui/icons';
import {
	useGetMfaPolicyQuery,
	useGetUserLogoQuery,
	useLoggedInUserProfileQuery,
	useResetMfaMutation,
	useSetMyMfaMutation,
} from 'generated/graphql';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { POSClient } from '../../POSClient';
import { AccountClient } from '../../ProductsClient';
import { GET_ACCOUNT_DETAIL } from './AccountQuery';
import { MFAEnrolment } from './MFAEnrolment';
import { MFA_COPY, mfaWrapStyle } from './MFACopy';

export const Profile = props => {
	let history = useHistory();

	let location = useLocation();

	const {
		loading,
		error,
		data: { loggedInUserProfile } = { loggedInUserProfile: null },
	} = useLoggedInUserProfileQuery({
		client: POSClient as any,
	});

	let dataToReturn = [];
	const [previewFile, setPreview] = useState(null);
	const {
		loading: accLoad,
		error: accError,
		data: { getAccountDetail } = { getAccountDetail: {} },
	} = useQuery(GET_ACCOUNT_DETAIL, {
		client: AccountClient as any,

		variables: {
			accountID: loggedInUserProfile?.accountID,
		},
	});

	const { data: userLogo } = useGetUserLogoQuery({
		skip: !loggedInUserProfile?.ID,
		variables: {
			refID: loggedInUserProfile?.ID as string,
		},
		onCompleted: data => {
			setPreview(data?.logoView?.fileURL);
		},
	});

	dataToReturn.push({ data: loggedInUserProfile });

	const [userData, setUserData] = useState({});
	const [accountDetailData, setAccountDetailData] = useState({});

	useEffect(() => {
		setUserData(loggedInUserProfile);
		setAccountDetailData(getAccountDetail);
	}, [loggedInUserProfile]);

	const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});

	const latestOutlet = localStorage.getItem('latestOutlet');

	const previousPath = localStorage.getItem('prevPath');

	const [mfaEnrolment, setMfaEnrolment] = useState<{
		mode: 'RESET' | 'ENABLE';
		otpURL?: string | null;
	} | null>(null);
	const [mfaMessage, setMfaMessage] = useState('');
	const [openMfaAlert, setOpenMfaAlert] = useState(false);

	const { data: mfaPolicyData, refetch: refetchMfaPolicy } = useGetMfaPolicyQuery(
		{
			client: POSClient as any,
			fetchPolicy: 'network-only',
		},
	);
	const mfaPolicy = mfaPolicyData?.getMfaPolicy;
	const showMfaSection = !!mfaPolicy?.enabled;
	const showMfaToggle = showMfaSection && !!mfaPolicy?.allowUserOptOut;
	const mfaOn = !!mfaPolicy?.is2FA;

	const onMfaError = (error: any) => {
		const gqlMessage = error?.graphQLErrors?.[0]?.message;
		setMfaMessage(gqlMessage || error?.message || 'Unable to update MFA');
		setOpenMfaAlert(true);
	};

	const [resetMfa, { loading: resetMfaLoading }] = useResetMfaMutation({
		client: POSClient as any,
		onError: onMfaError,
		onCompleted: ({ resetMfa }) => {
			setMfaEnrolment({ mode: 'RESET', otpURL: resetMfa?.otpURL });
		},
	});

	const [setMyMfa, { loading: setMyMfaLoading }] = useSetMyMfaMutation({
		client: POSClient as any,
		onError: onMfaError,
		onCompleted: ({ setMyMfa }) => {
			refetchMfaPolicy();
			if (setMyMfa?.otpURL) {
				setMfaEnrolment({ mode: 'ENABLE', otpURL: setMyMfa.otpURL });
			}
		},
	});

	const handleCloseMfaEnrolment = () => {
		setMfaEnrolment(null);
		refetchMfaPolicy();
	};

	if (mfaEnrolment) {
		return (
			<MFAEnrolment
				mode={mfaEnrolment.mode}
				otpURL={mfaEnrolment.otpURL || undefined}
				onClose={handleCloseMfaEnrolment}
				onConfirmed={handleCloseMfaEnrolment}
			/>
		);
	}

	return (
		<>
			{(loading || resetMfaLoading || setMyMfaLoading) && <Loading />}
			<MainHeader
				mainBtn="back"
				onClick={() => {
					// 	history.push(`/menu/outlet-app/${latestOutlet}/table/grid`);
					history.push(`${previousPath}`);
					localStorage.removeItem('prevPath');
				}}
				smTitle={'Outlet App'}
				title="Profile"
				routeSegments={[{ name: 'My Profile', current: true }]}
				rightRouteSegments={[{ name: 'Edit ', current: true }]}
			/>

			<div
				style={{
					marginTop: isDesktop ? '61px' : '0px',
					marginBottom: isDesktop ? '-45px' : '10px',
				}}
			>
				<img src={Cover} alt="" className="profile-cover" />
				{/* <img src={userLogo?.logoView?.fileURL} alt="" className="user-avatar" /> */}

				{!previewFile ? (
					<img src={DefaultAvatar} alt="" className="user-avatar" />
				) : (
					<img
						src={userLogo?.logoView?.fileURL}
						alt=""
						className="user-avatar"
					/>
				)}
			</div>

			<ContentWrapper>
				<CardContents
					devFullWidth={true}
					section={{
						header: {
							title: loggedInUserProfile?.name,
							onClickAction: () =>
								history.push({
									pathname: `/profile/edit`,
									state: { userData, accountDetailData, previewFile },
								}),
							icon: <Edit />,
						},
					}}
				>
					<div className="content-wrap full">
						<div className="desc">Email</div>
						<EmailText font="xsTitle">{loggedInUserProfile?.email}</EmailText>
					</div>
					<div className="content-wrap full">
						<div className="desc">Mobile No.</div>
						<PhoneText font="xsTitle">
							{loggedInUserProfile?.contactNo}
						</PhoneText>
					</div>
					{/* <div className="content-wrap full">
						<div className="desc">Company</div>
						<div className="xsTitle">{getAccountDetail?.name}</div>
					</div> */}
					{/* <div className="content-wrap full">
						<div className="desc">Department</div>
						<div className="xsTitle">
							{loggedInUserProfile.department ?? 'NA'}{' '}
						</div>
					</div>
					<div className="content-wrap full">
						<div className="desc">Job Title</div>
						<div className="xsTitle">
							{loggedInUserProfile.jobTitle ?? 'NA'}
						</div>
					</div> */}
				</CardContents>
				{showMfaSection && (
					<CardContents
						devFullWidth={true}
						section={{
							header: { title: MFA_COPY.sectionTitle },
						}}
					>
						{showMfaToggle && (
							<div className="content-wrap full">
								<div className="desc">{MFA_COPY.sectionTitle}</div>
								<div className="xsTitle">
									<Switch
										color="primary"
										checked={mfaOn}
										disabled={setMyMfaLoading}
										onChange={e =>
											setMyMfa({ variables: { enabled: e.target.checked } })
										}
									/>
									<span className="xsTitle">{mfaOn ? 'On' : 'Off'}</span>
								</div>
							</div>
						)}
						<div className="content-wrap full">
							<div style={mfaWrapStyle}>{MFA_COPY.resetRemovesPrevious}</div>
						</div>
						<div className="content-wrap full">
							<Button
								variant="contained"
								color="primary"
								size="small"
								disabled={resetMfaLoading}
								onClick={() => resetMfa()}
							>
								{MFA_COPY.resetAction}
							</Button>
						</div>
					</CardContents>
				)}
				<List className="core-list">
					<ListItem>
						<IconItem
							image={Authentication}
							imageType="svg"
							badgeType="default"
						/>
						<ListItemText
							onClick={() =>
								history.push({ pathname: '/profile/change-password' })
							}
							primary={<span className="xsTitle">Change Password</span>}
						/>
						<ListItemSecondaryAction>
							<IconButton edge="end" aria-label="arrow">
								<KeyboardArrowRight
									onClick={() =>
										history.push({ pathname: '/profile/change-password' })
									}
								/>
							</IconButton>
						</ListItemSecondaryAction>
					</ListItem>
					<ListItem onClick={() => history.push(`/logout`)}>
						<IconItem image={Logout} imageType="svg" badgeType="default" />
						<ListItemText primary={<span className="xsTitle">Logout</span>} />
						<ListItemSecondaryAction>
							<IconButton edge="end" aria-label="arrow">
								<KeyboardArrowRight onClick={() => history.push(`/logout`)} />
							</IconButton>
						</ListItemSecondaryAction>
					</ListItem>
				</List>
			</ContentWrapper>
			<CommonDialog
				fullWidth={true}
				open={openMfaAlert}
				onClose={() => setOpenMfaAlert(false)}
				sections={{
					header: { title: MFA_COPY.sectionTitle },
					body: () => <div>{mfaMessage}</div>,
					footer: {
						actions: [
							{
								displayText: 'Ok',
								props: {
									onClick: () => setOpenMfaAlert(false),
									variant: 'contained',
									color: 'primary',
								},
							},
						],
					},
				}}
			/>
		</>
	);
};
